import { Card, Dropdown, Header } from "semantic-ui-react";

import { useTranslation } from "react-i18next";

import DropdownMenu from "astrid-web/src/features/ui/components/DropdownMenu/DropdownMenu";
import ErrorMessage from "astrid-web/src/features/ui/components/Messages/ErrorMessage";
import Message from "astrid-web/src/features/ui/components/Messages/Message";
import useSingleFileUpload from "astrid-web/src/features/ui/hooks/useSingleFileUpload";

import Flex from "../../../../../components/Flex/Flex";
import useResetPassword from "../../../../authentication/hooks/useResetPassword";
import ImageAvatarNew from "../../../../ui/components/ImageAvatarNew/ImageAvatarNew";
import getUserInitials from "../../../../users/utils/getUserInitials";

export default function AccountInfo({ user }) {
	const { t } = useTranslation();
	const [{ input, loading, uploadFile }] = useSingleFileUpload({
		bucketName: "earselect-uploads",
		accept: "image/*",
		getDestination: () => `profileImages/${user.id}`,
	});

	const { resetPassword, loading: loadingPasswordReset, error, message } = useResetPassword(user);

	return (
		<Card fluid>
			<Card.Content>
				<Flex>
					<Flex justifyContent="flex-start" gap={10}>
						<ImageAvatarNew src={user.img} abbr={getUserInitials(user)} />

						<Header style={{ margin: 0 }}>
							{user.firstName} {user.lastName}
							<Header.Subheader>{user.email}</Header.Subheader>
						</Header>
					</Flex>
					<DropdownMenu loading={loading}>
						{() => (
							<>
								<Dropdown.Item
									text={t("uploadNewProfilePicture", "Upload new profile picture")}
									onClick={uploadFile}
								/>
								<Dropdown.Item
									loading={loadingPasswordReset}
									text={t("setNewPassword", "Set new password")}
									onClick={resetPassword}
								/>
							</>
						)}
					</DropdownMenu>
				</Flex>

				{message && <Message dismissible>{message}</Message>}

				{error && <ErrorMessage error={error}>{t("errorMessageHeader", "Something went wrong")}</ErrorMessage>}
			</Card.Content>
			{input}
		</Card>
	);
}
